import { render, staticRenderFns } from "./UserSessionDetail.vue?vue&type=template&id=71842773"
import script from "./UserSessionDetail.vue?vue&type=script&lang=js"
export * from "./UserSessionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports